"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const lifeStages = [{
  title: "Körper, Geist und Natur im Einklang",
  content: "Training des Körpers ist stets auch Training des Geistes. Die Natur des Soonwalds ist dabei unser Wegweiser zu einer harmonischen Existenz: Innere Natur im Einklang mit der äußeren Natur. Wir üben deshalb wann immer möglich draußen im Freien. Natur, Bewegung und Bewusstheit sind immer Bestandteil eines ganzheitlichen Übungsweges."
}];
export default function VitaPhilosophie() {
  const {
    ref: leftColumnRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightColumnRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="144793" id="kraft-der-bewegung" className="bg-[#FAF6F1] py-40 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          
          <div ref={leftColumnRef} className={`relative flex flex-col gap-8 transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <img alt="Sonnendurchfluteter Bachlauf im Soonwald" className="w-full aspect-[4/5] lg:aspect-auto lg:h-[700px] object-cover rounded-2xl shadow-sm" src="https://tai-chi-soonwald.de/wp-content/uploads/2026/10/image-20260927-165947-673.jpeg" />
          </div>

          <div ref={rightColumnRef} className={`flex flex-col transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="mb-16">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-sans font-light text-[#4A5D23] mb-8 tracking-tight leading-tight">Herzlich willkommen im Soonwald</h2>
              <p className="text-lg md:text-xl text-[#333333] font-light leading-relaxed">Authentische Bewegungskunst, Gesundheit und innere Ruhe - hier im Herzen des Soonwaldes findest Du traditionelle Wege und modernes Resilienztraining harmonisch unter einem Dach vereint. Lerne mit professioneller Begleitung die Essenz von Tai Chi, Qi Gong, Yoga und Achtsamkeitsmeditation kennen, und entdecke, wie Deine persönliche Übungspraxis aussehen könnte.</p>
            </div>

            <div className="flex flex-col">
              {lifeStages.map((stage, i) => <div key={i} data-index={i} className="flex flex-col">
                  {i > 0 && <Separator className="my-10 bg-[#E0E0E0]" />}
                  <div className="group">
                    <h3 className="text-xl md:text-2xl font-sans font-normal text-[#4A5D23] mb-4 group-hover:text-[#2C5F63] transition-colors duration-300">
                      {stage.title}
                    </h3>
                    <p className="text-[#333333] leading-relaxed text-base md:text-lg font-light indent-0" dangerouslySetInnerHTML={{
                  __html: stage.content
                }} />
                  </div>
                </div>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}